export default {
  "cashTransferRecord.thead.userno": "用户ID",
  "cashTransferRecord.thead.transferId": "转账ID",
  "cashTransferRecord.thead.providerAgentDesc": "厂商",
  "cashTransferRecord.thead.amount": "变动金额",
  "cashTransferRecord.thead.beforeBalanceAmount": "转账前平台余额",
  "cashTransferRecord.thead.beforeGameBalance": "转账前厂商余额",
  "cashTransferRecord.thead.afterBalanceAmount": "转账后平台余额",
  "cashTransferRecord.thead.afterGameBalance": "转账后厂商余额",
  "cashTransferRecord.thead.operationDetail": "转账说明",
  "cashTransferRecord.thead.statusDesc": "转账状态",
  "cashTransferRecord.thead.createTime": "转账时间",
  "cashTransferRecord.thead.action": "操作",
  "cashTransferRecord.action.updateStatus": "改变状态",
  "cashTransferRecord.action.updateStatus.confirmTitle": "确认修改转账状态？",
  "cashTransferRecord.action.updateStatus.confirmContent": "转账单：{transferId}",
  "cashTransferRecord.action.updateStatus.confirmOk": "确认",
  "cashTransferRecord.action.updateStatus.confirmCancel": "取消",
  "cashTransferRecord.action.updateStatus.field.status": "目标状态",
  "cashTransferRecord.action.updateStatus.field.status.required": "请选择目标状态",
  "cashTransferRecord.action.updateStatus.success": "状态修改成功",
  "cashTransferRecord.action.updateStatus.failed": "状态修改失败",
  "cashTransferRecord.status.success": "成功",
  "cashTransferRecord.status.failed": "失败",
  "cashTransferRecord.direction.in": "转入游戏钱包",
  "cashTransferRecord.direction.out": "转出游戏钱包",
  "cashTransferRecord.direction.unknown": "未知",
};
